import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/AlertDialog";
import { Button } from "@/components/ui/Button";
import { deductBalanceToAdmin } from "@/services/orders";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { toast } from "sonner";

export default function DeductToAdminButton({ userId, orderId, onSuccess }) {
  const { t } = useTranslation("orders");
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await deductBalanceToAdmin(userId, orderId);
      toast.success(t("deduct_to_admin.success"));
      onSuccess?.();
    } catch {
      toast.error(t("deduct_to_admin.error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          size="icon"
          variant="ghost"
          className="h-8 w-8 text-blue-600 hover:text-blue-700"
          title={t("deduct_to_admin.title")}
        >
          <MdOutlineAccountBalanceWallet className="text-[1.1rem]" />
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("deduct_to_admin.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("deduct_to_admin.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>
            {t("deduct_to_admin.cancel")}
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleConfirm} disabled={loading}>
            {t("deduct_to_admin.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
